import { render, staticRenderFns } from "./mktRecaptcha.vue?vue&type=template&id=25643f48&"
import script from "./mktRecaptcha.vue?vue&type=script&lang=js&"
export * from "./mktRecaptcha.vue?vue&type=script&lang=js&"
import style0 from "./mktRecaptcha.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports